import { useEffect, useState } from 'react';
import { useProductCardSize } from '../../../hooks/useProductCardSize';

export const useAnalyticsProductCardViewUpdate = () => {
  const { isLargeCardSize } = useProductCardSize();
  const [isLargeCardsEnabled, setIsLargeCardsEnabled] =
    useState(isLargeCardSize);

  useEffect(() => {
    setIsLargeCardsEnabled(isLargeCardSize);
  }, [isLargeCardSize]);

  return {
    isLargeCardsEnabled,
  };
};
